import { CALENDAR_MONTHS } from 'constants/dateOptions';
import { InfluencerTypes } from '../api';

const getChartOptions = ({
  key,
  chartData,
  avgData,
}: {
  key: string;
  chartData:
    | InfluencerTypes.DealsChartData
    | {
        [key: string]: Record<string, number>;
      };
  avgData: Record<string, number>;
}) => {
  const data: Record<
    string,
    number | { total_budget: number; total_revenue: number }
  > =
    'budget_revenue' in chartData
      ? chartData.budget_revenue
      : chartData[key as keyof typeof chartData];

  const years = Object.keys(data)
    .map((d) => +d.split(' ')[1])
    .filter((v, i, a) => a.indexOf(v) === i);

  const opt = years
    .map((year) => CALENDAR_MONTHS.map((month) => ({ ...month, year })))
    .flat();

  return opt.map((option) => {
    const key = `${option.monthName} ${option.year}`;

    const value = key in data ? data[key] : 0;
    const avgValue = key in avgData ? avgData[key] : 0;

    const budget = typeof value === 'object' ? value.total_budget : 0;
    const revenue = typeof value === 'object' ? value.total_revenue : 0;

    return {
      ...option,
      date: key,
      value,
      avgValue,
      budget,
      revenue,
    };
  });
};

export { getChartOptions };
